import styled from 'styled-components';

const ContainerStyled = styled.div`
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;
  gap: 20px;
  padding: 0 20px;
`;

const DatesStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  border-bottom: solid 1px #c9cfd7;
  padding-bottom: 20px;

  div {
    text-align: center;
  }
`;

const AmountStyled = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const PriceStyled = styled.div`
  font-size: 26px;
  font-weight: 600;
  color: #0e141d;
  display: flex;
  gap: 8px;
`;

export { ContainerStyled, DatesStyled, AmountStyled, PriceStyled };
